export default __webpack_public_path__ + "static/media/Path 137.77795e55.svg";